module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "base-dialog",
    attrs: {
      "title": undefined,
      "show-close": true,
      "close-on-click-modal": true,
      "visible": _vm.visible,
      "width": _vm.isDesktop ? '60%' : '90%',
      "modal-append-to-body": false,
      "modal": false
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.noFooter) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0a0e32e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog.vue
// module id = 940
// module chunks = 1